import baseStyles from '../Base/Base.styles'
import BaseImageStyles from '../BaseImage/BaseImage.styles'
import {responsiveTextAlignment} from '../Base/responsiveAlignment'
import SwipeableGridStyles from '../SwipeableGrid/SwipeableGrid.styles'

export default properties => {

  const { base, image, bodyText, jobText, authorText, swipeableGrid } = properties
  
  let jss = {
    root: {
      ...baseStyles(base),
      ...responsiveTextAlignment(base.alignment),
      '--body-text': bodyText,
      '--job-text': jobText,
      '--author-text': authorText,
      
      '& .body': {
        position: 'relative',
        fontSize: '20px',
        marginBottom: '16px'
      },

      '& .image': BaseImageStyles(image),
      '& .grid-wrapper': SwipeableGridStyles(swipeableGrid)

    }
  }

  return jss
}
